import Vue from 'vue';
import App from './App.vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import VueI18n from 'vue-i18n';
import { Icon } from 'vant';
import 'video.js/dist/video-js.css'
import VueCookies from 'vue-cookies'

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false

Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(Icon);
Vue.use(VueI18n);
Vue.use(VueCookies)

// ✅ 默认使用繁体(zh)，如果用户本地存了 lang 就按本地来
const defaultLang = (localStorage.getItem("lang") || "zh").trim()

const i18n = new VueI18n({
  globalInjection: true,
  locale: defaultLang,
  fallbackLocale: "zh",
  messages: {
    zh: require('./assets/languages/zh.json'),
    en: require('./assets/languages/en.json'),
    ja: require('./assets/languages/ja.json'),
    kr: require('./assets/languages/kr.json')
  }
});

// ✅ 如果之前存的是 ja，强制切到 zh（你不想强制就删掉这段）
if (defaultLang === 'ja') {
  i18n.locale = 'zh'
  localStorage.setItem('lang', 'zh')
}

new Vue({
  store,
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')
